(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['@leancode/cx'] = {}));
}(this, (function (exports) { 'use strict';

    var RawClassName = (function () {
        function RawClassName(className) {
            this.className = className;
        }
        return RawClassName;
    }());
    function rawClassName(className) {
        return new RawClassName(className);
    }
    function mkCx(styles) {
        function mapClassToString(c) {
            if (c instanceof RawClassName) {
                return c.className;
            }
            if (typeof c === "string") {
                return styles[c];
            }
            return undefined;
        }
        function joinTwoClasses(left, right) {
            if (left && right) {
                return left + " " + right;
            }
            else if (left) {
                return left;
            }
            else if (right) {
                return right;
            }
            return undefined;
        }
        var f = function () {
            var classes = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                classes[_i] = arguments[_i];
            }
            return classes.reduce(function (prev, c) {
                if (Array.isArray(c)) {
                    return joinTwoClasses(prev, f.apply(void 0, c));
                }
                if (c !== null && typeof c === "object" && !(c instanceof RawClassName)) {
                    for (var key in c) {
                        if (c[key]) {
                            prev = joinTwoClasses(prev, mapClassToString(key));
                        }
                    }
                    return prev;
                }
                return joinTwoClasses(prev, mapClassToString(c));
            }, undefined);
        };
        return f;
    }

    exports.RawClassName = RawClassName;
    exports.default = mkCx;
    exports.rawClassName = rawClassName;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map
